var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"col",staticStyle:{"word-break":"keep-all","padding":"0px"},style:({'min-width': _vm.textlength+'ch', 'margin': _vm.margin+'px', 'padding': '5px'})},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }